import { FC } from "react";
import { HStack, Text } from "@chakra-ui/react";

import { Info2Icon } from "../../../../../icons";

export const CHDPModalInfo: FC = () => {
  const message = "Платёж в Частичное досрочное погашение уменьшит будущие платежи по графику. "
    + "Платёж в Полное досрочное погашение закроет задолженность полностью.";

  return (
    <HStack
      spacing="4px"
      px="11px"
      py="9px"
      mb="10px"
      alignItems="flex-start"
      backgroundColor="gold.50"
      border="1px solid"
      borderColor="gold.500"
      borderRadius="10px"
    >
      <Info2Icon color="gold.500" mr="4px" />

      <Text fontSize="14px" lineHeight="19px" variant="brand">
        {message}
      </Text>
    </HStack>
  );
};
